import React, {
    FC,
    useState,
} from "react";
import {useTranslation} from "react-i18next";
import {
    Box,
    Menu,
    MenuItem,
    Typography,
} from "@mui/material";
import Flag from "react-world-flags";
import {
    ArrowDropDown,
    Language,
} from "@mui/icons-material";

const languages = [
    {
        code: "en",
        label: "English",
        flag: "GB",
    },
    {
        code: "ge",
        label: "ქართული",
        flag: "GE",
    },
];
export const LanguageSwitcher: FC = () => {
    const {i18n} = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const currentLanguage = languages.find(
        (lang) => lang.code === i18n.language,
    );
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        if (anchorEl) {
            setAnchorEl(null);
        }
        else {
            setAnchorEl(event.currentTarget);
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        handleClose();
    };
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: theme => theme.palette.button.primary,
                color: theme => theme.palette.button.text,
                border: "1px solid rgba(0, 0, 0, 0.1)",
                borderRadius: "4px",
                padding: "3px 6px",
                height: 30,
                "&:hover": {
                    backgroundColor: theme => theme.palette.button.hover,
                },
                transition: "background-color 0.2s",
            }}
            onClick={handleClick}
        >
            <Language
                fontSize="small"
                sx={{
                    marginRight: "8px",
                    color: theme => theme.palette.button.text,
                }}
            />
            <Typography
                variant="body2"
                sx={{
                    fontWeight: 500,
                    color: theme => theme.palette.button.text,
                    marginRight: "4px",
                }}
            >
                {currentLanguage?.label || "English"}
            </Typography>
            <ArrowDropDown
                sx={{
                    transition: "transform 0.2s",
                    transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
                }}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        width: 150,
                        backgroundColor: theme => theme.palette.card.background,
                        borderRadius: 1,
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    },
                }}
            >
                {languages.map((language) => (
                    <MenuItem
                        key={language.code}
                        onClick={() => changeLanguage(language.code)}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Flag
                            code={language.flag}
                            width={30}
                            height={20}
                            style={{marginRight: 8}}
                        />
                        {language.label}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};
